import ThemeWrapper from "./src/ThemeWrapper";

export default ThemeWrapper;
